import { AgmMap, AgmMarker } from '@agm/core';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window';
import {
  Component, OnInit, QueryList, ViewChild, ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { isNullOrUndefined, clone } from '../../../common/extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { HubEvent } from '../../../models/hub/hub.event';
import { ConfigService } from '../../../services/config.service';
import { EventTimeService } from '../../../services/event.time.service';
import { GeoService } from '../../../services/geo.service';
import { ImageService } from '../../../services/image.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
import { config } from '../../../../config/config';
import { EventDetailsModalActions } from "../event.details.modal/event.details.modal.provider";
import { ButtonTriggerEvent } from "../../../common/components";
import { EventDetailsModalComponent } from "../event.details.modal/event.details.modal.component";
import { TripDetailModalActions, TripDetailModalData } from "../trip/trip.detail.modal/trip.detail.modal.provider";
import { TripDetailModalComponent } from "../trip/trip.detail.modal/trip.detail.modal.component";
import { ModalService } from "../../../common/services/modal.service";
import { AllFrontendSettingsCommand } from "../../../commands/visitor/all.frontend.settings.command";
import { CustomEventCommand } from "../../../commands/hub/custom.event.command";
import { localStorageKeys } from "../../../common/constants/local.storage.keys";

@Component({
  selector: 'ig-event-map',
  templateUrl: './visitor.event.map.component.html',
  styleUrls: [
    './visitor.event.map.component.scss',
    '../../../../node_modules/snazzy-info-window/dist/snazzy-info-window.css'
  ],
  encapsulation: ViewEncapsulation.None
})
export class VisitorEventMapComponent extends BaseComponent implements OnInit {
  public lat: number = ConfigService.config.google.USCenter.lat;
  public lng: number = ConfigService.config.google.USCenter.lng;
  public events: HubEvent[];
  public allEvents: HubEvent[];
  public isLoading = false;
  public paginationIndex = 0;
  public paginationPageLimit = 20;
  public noMoreNext = false;
  public noMoreBack = true;
  public event: HubEvent;
  public hubName: string;
  public actionCommand = new VisitorCalendarActionCommand();
  public latLngBounds: any;
  public showingCount: string;
  public currentIndex: any;
  public showGroupInfowWindow = false;
  public canMarkerMouseOver = true;
  public isInfoWindowsOpen: any[];
  public markerOverlappings: any[][];
  public groupEvents: HubEvent[];
  public groupLat = 0;
  public groupLng = 0;
  public iconUrl = ConfigService.config.google.iconUrl;
  public hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
  public isSideBarOpened = false;
  public isNeedSideEventList = false;
  public isMapFullSize = false;
  public customEvents: CustomEventCommand[] = [];

  @ViewChild(AgmMap) public map: AgmMap;
  @ViewChildren(AgmSnazzyInfoWindow) snazzyWindowChildren: QueryList<AgmSnazzyInfoWindow>;
  @ViewChildren(AgmMarker) mapMarkers: QueryList<AgmMarker>;

  constructor(private router: Router,
              private visitorApiService: VisitorApiService,
              private googleMapService: GoogleMapsService,
              private imageService: ImageService,
              public modalService: ModalService,
              private visitorCalendarStore: VisitorCalendarStore,
              private allFrontendSettingsStore: AllFrontendSettingsStore,
              private activatedRoute: ActivatedRoute) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    this.actionCommand.isMapView = true;
    // this.visitorCalendarStore.actionCommand.next(this.actionCommand);

    // this.getEvents();

    this.allFrontendSettingsStore.allFrontendSettingsCommand.takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.customSettings) {
          this.customEvents = command.customSettings.customEvents || null;
        }
      });

    this.visitorCalendarStore.actionCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: VisitorCalendarActionCommand) => {
        console.log('command got in map', command);
        this.actionCommand = clone(command);

        this.getEvents();
      });
  }

  public getEvents() {
    this.isLoading = true;
    this.isInfoWindowsOpen = [];
    let limit = config.searchLimit; // 0 represents no limit, but seems only 9 records can be found if this set to 0
    this.actionCommand.queryCommand.limit = limit;
    this.visitorApiService.getEvents(this.hubName, this.actionCommand.queryCommand
      // {limit: limit, page: 1, category: this.actionCommand.queryCommand.category}
    )
      .subscribe(data => {
        data = data.filter(x => x.address && !x.isOnlineEvent);
        EventTimeService.formatEventTime(data);
        this.allEvents = data;

        if (data.length > this.paginationPageLimit) {
          let max = this.paginationPageLimit * (this.paginationIndex + 1);
          max = max < this.allEvents.length ? max : this.allEvents.length;
          this.events = data.slice(0, max);
          this.showingCount = `${this.paginationPageLimit * this.paginationIndex + 1} - ${max}`;
        } else {
          this.events = data;
          this.showingCount = null;
        }

        this.events.forEach(x => {
          this.isInfoWindowsOpen.push(false);
        });
        this.fitBounds();
        this.isLoading = false;
      });
  }

  public showInfoWindowOnMarker(index: number) {
    if (!this.canMarkerMouseOver) {
      return;
    }

    let overlapGroup = [];
    this.markerOverlappings.forEach(x => {
      if (x.any(y => y === index)) {
        overlapGroup = x;
      }
    });

    if (overlapGroup.length) {
      console.log(overlapGroup.map(x => {
        return x;
      }));

      this.groupEvents = [];
      let lat = 0;
      let lng = 0;

      overlapGroup.forEach(x => {
        this.groupEvents.push(this.events[x]);
        let marker = this.mapMarkers.find((m, i) => {
          return i === x;
        });
        lat += marker.latitude;
        lng += marker.longitude;
      });

      this.groupLat = lat / overlapGroup.length;
      this.groupLng = lng / overlapGroup.length;

      this.hideAllSingleInfoWindow();
      this.showGroupInfowWindow = true;
    } else {
      this.showInfoWindowByIndex(index);
    }
  }

  public showInfoWindowByIndex(index: number) {
    this.hideAllSingleInfoWindow();
    this.currentIndex = index;

    setTimeout(() => {
      this.isInfoWindowsOpen[index] = true;
      this.showGroupInfowWindow = false;
    });
  }

  public groupInfoWindowCloses() {
    this.showGroupInfowWindow = false;
  }

  public mapZoomChange() {
    this.organizeMarkersForOverlapping();
    this.hideAllInfoWindow();
  }

  public removeDisplayInfoWindow() {
    this.canMarkerMouseOver = false;
    // this.mapMarkers.forEach(marker => {
    //     marker.mouseOver.complete();
    // });
  }

  public addDisplayInfoWindow() {
    setTimeout(() => {
      this.canMarkerMouseOver = true;
    }, 200);
  }

  public pagingBack() {
    if (this.noMoreBack) {
      return;
    }

    this.paginationIndex--;
    let start = this.paginationPageLimit * this.paginationIndex;
    let end = start + this.paginationPageLimit;
    if (start <= 0) {
      start = 0;
      this.noMoreBack = true;
    }
    this.events = this.allEvents.slice(start, end);
    this.showingCount = `${start + 1} - ${end}`;
    this.noMoreNext = false;
    this.fitBounds();
  }

  public pagingNext() {
    if (this.noMoreNext) {
      return;
    }

    this.paginationIndex++;
    let start = this.paginationPageLimit * this.paginationIndex;
    let end = start + this.paginationPageLimit;
    if (end >= this.allEvents.length) {
      end = this.allEvents.length;
      this.noMoreNext = true;
    }
    this.events = this.allEvents.slice(start, end);
    this.showingCount = `${start + 1} - ${end}`;
    this.noMoreBack = false;
    this.fitBounds();
  }

  public back() {
    this.actionCommand.isMapView = false;
    this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar,
      {
        hubName: this.hubName
      }), {skipLocationChange: this.noChangeUrlWhenRedirect});
    setTimeout(() => {
      this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    });
  }

  public resizeMap() {
    this.isMapFullSize = !this.isMapFullSize;
  }

  private organizeMarkersForOverlapping() {
    this.markerOverlappings = [];
    this.mapMarkers.forEach((x, indexX) => {
      this.mapMarkers.forEach((y, indexY) => {
        if (x !== y) {
          if (this.isMarkersOverlapping(x, y)) {
            let toInsert = true;
            this.markerOverlappings.forEach(m => {
              if (m.any(o => o === indexX || o === indexY)) {
                if (!m.any(o => o === indexX)) {
                  m.push(indexX);
                }
                if (!m.any(o => o === indexY)) {
                  m.push(indexY);
                }
                toInsert = false;
              }
            });
            if (toInsert) {
              this.markerOverlappings.push([indexX, indexY]);
            }
          }
        }
      });
    });
  }

  private isMarkersOverlapping(marker1: AgmMarker, marker2: AgmMarker) {
    let zoom = this.map.zoom;
    let dis = GeoService.getDistanceFromLatLng(marker1.latitude, marker1.longitude, marker2.latitude, marker2.longitude);

    let metersPerPx = 156543.03392 * Math.cos(marker1.latitude * Math.PI / 180) / Math.pow(2, zoom);
    let pxDistance = dis / metersPerPx;

    return pxDistance <= 10;
  }

  private hideAllSingleInfoWindow() {
    for (let i = 0; i < this.isInfoWindowsOpen.length; i++) {
      this.isInfoWindowsOpen[i] = false;
    }
  }

  private hideAllInfoWindow() {
    this.hideAllSingleInfoWindow();
    this.showGroupInfowWindow = false;
  }

  public hideInfoWindow(marker: any) {
    // this.timeout = setTimeout(function () {
    //     // marker._closeInfoWindow();
    // }, 1500);
  }

  public showDetails(id: string) {
    const event = this.events.find(x => x._id === id);
    if (!this.isMobile) {
      event.hubName = this.hubName;
      let actions = <EventDetailsModalActions>{
        confirm: (event: ButtonTriggerEvent, data: any) => {
        }
      };

      this.modalService.show({
        component: EventDetailsModalComponent,
        providers: [
          {provide: EventDetailsModalActions, useValue: actions},
          {provide: HubEvent, useValue: event},
        ],
        panelClass: 'modal-fixed-top-lower'
      });
    } else {
      this.showDetailModalForMobile(event, 'event');
    }
  }

  public showDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = false, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {

      }
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(item, displayingOn, this.hubName,
            null, null, isShowAddToTripBtn, index)
        }
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }

  private fitBounds() {
    this.googleMapService.getGoogle().then(() => {
      this.latLngBounds = new google.maps.LatLngBounds();

      this.events.forEach(x => {
        if (!isNullOrUndefined(x.address.lat) && !isNullOrUndefined(x.address.lng)) {
          this.latLngBounds.extend(new google.maps.LatLng(x.address.lat, x.address.lng));
        }
      });
    });
  }

  public openedChange() {
    return !this.isNeedSideEventList;
  }
}




// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.map/visitor.event.map.component.ts